let inputs = document.querySelectorAll(".card-form input");
document.addEventListener("click", function (e) {
  if (
    e.target.classList.contains("variant-head") ||
    e.target.closest(".variant-head")
  ) {
    let el = e.target.classList.contains("variant-head")
      ? e.target
      : e.target.closest(".variant-head");
    el.closest(".dropdown").classList.toggle("open");
  }
});
inputs.forEach(function (el, ind) {
  el.addEventListener("change", function (e) {
    let data = JSON.parse(el.closest("form").querySelector("script").innerText);
    let formInput = el.closest("form").querySelector('input[name="id"]');
    let ajaxButton = el.closest("form").querySelector(".ajax-cart");
    let options = el.closest("form").querySelectorAll('input[type="radio"]');
    let image1 = el
      .closest(".product-card")
      .querySelector(".card-image-wrap img");
    let image2 = el.closest(".product-card").querySelector(".product-image-2");
    image2 ? (image2.style.display = "none") : "";
    let selectedOptions = [];
    let selectedOptionData;
    let available;
    image1 ? image1.setAttribute("backdrop-filter", "blur(1px)") : "";
    options.forEach(function (el, ind) {
      if (el.checked) {
        selectedOptions.push(el.value);
      }
    });
    data.variants.forEach(function (el, ind) {
      if (
        el.options.length == selectedOptions.length &&
        el.options.every((el) => selectedOptions.indexOf(el) != -1)
      ) {
        selectedOptionData = el;
      }
    });
    console.log(selectedOptionData);
    formInput.value = selectedOptionData.id;
    console.log(formInput);
    available = selectedOptionData.available;
    if (ajaxButton) {
      available
        ? ajaxButton.removeAttribute("disabled")
        : ajaxButton.setAttribute("disabled", true);
    }
    image1 &&
    selectedOptionData.featured_image &&
    selectedOptionData.featured_image.src
      ? image1.setAttribute("src", selectedOptionData.featured_image.src)
      : "";
    image1 &&
    selectedOptionData.featured_image &&
    selectedOptionData.featured_image.src
      ? image1.setAttribute("srcset", selectedOptionData.featured_image.src)
      : "";
    image1 ? image1.setAttribute("backdrop-filter", "blur(0px)") : "";
  });
});
document.addEventListener("click",(e)=>{
  if(e.target.classList.contains("play-pause-btn") || e.target.closest(".play-pause-btn")){
    let el = e.target.classList.contains("play-pause-btn") ? e.target : e.target.closest(".play-pause-btn");
    let audio = el.closest(".product-audio").querySelector("audio");
    if(audio.paused){
      audio.play();
      el.querySelector(".icon-pause").style.display = "flex";
      el.querySelector(".icon-play").style.opacity = "0";
      el.querySelector(".icon-play").style.display = "none";
      setTimeout(()=>{
        el.querySelector(".icon-pause").style.opacity = "1";
      },0)
    }else{
       audio.pause();
      el.querySelector(".icon-play").style.display = "flex";
      el.querySelector(".icon-pause").style.opacity = "0";
      el.querySelector(".icon-pause").style.display = "none";
      setTimeout(()=>{
        el.querySelector(".icon-play").style.opacity = "1";
      },0)
    }
  }
})